export { default as ProductPromoBannerCarousel } from './ProductPromoBannerCarousel';
